import { FC, memo } from 'react';

import { ListCardCollects } from '../../../../../../components/List/Collects/styles';
import { QualidadeItem } from '../../page';
import { QualityCard } from '../card';

interface IListCardsQuality {
  data: QualidadeItem[];
  onVisualize: (analysis: QualidadeItem) => void;
}

const ListCardsQuality: FC<IListCardsQuality> = memo(
  ({ data, onVisualize }) => {
    return (
      <ListCardCollects>
        {data.map(analysis => (
          <QualityCard
            key={analysis.DFIDCALCANALISE}
            analysis={analysis}
            onVisualize={onVisualize}
          />
        ))}
      </ListCardCollects>
    );
  },
);

ListCardsQuality.displayName = 'ListCardsQuality';

export { ListCardsQuality };
